import styled, { css } from 'styled-components';
import { paletteHelper, spacingHelper } from '@construct-kit/core';
import { layout } from '../../../../styles/_variables';

export const StyledContainer = styled.div`
  background: ${paletteHelper('backgroundPrimaryLow')};
  margin: 0;
  position: sticky;
  top: 0;
  z-index: 98;
  border-bottom: 1px solid ${paletteHelper('borderSecondary')};
  padding: ${spacingHelper('0 medium')};

  ${({ theme }) => css`
    ${theme.layoutBreakpoints.extraLarge} {
      top: 5rem;
    }
  `}

  @media (min-width: ${layout.maxWidthDesktopWide}) {
    padding: 0;
  }
`;

export const Grid = styled.div<{ fullWidth: boolean }>`
  display: grid;
  grid-template-columns: 1fr;
  padding: ${spacingHelper('small 0')};
  justify-content: center;
  ${({ theme }) => css`
    ${theme.layoutBreakpoints.extraLarge} {
      margin: 0 auto;
      grid-template-columns: auto 1fr;
      grid-column-gap: ${theme.spacing.medium};
    }
  `}

  @media (min-width: ${layout.maxWidthDesktopWide}) {
    min-width: ${layout.maxWidthDesktopWide};
    width: ${({ fullWidth }) => (fullWidth ? '100%' : 0)};
    padding: ${spacingHelper('small medium')};
  }
`;

const pillPaddingPx = 8;
const btnPaddingPx = 24;
const smChannelPillWidthPx = 81;
const smPptyTypePillWidthPx = 162;
const smPricePillWidthPx = 149;
const smFloorAreaPillWidthPx = 180;
const smAllFiltersBtnWidthPx = 72;
const smlHidePropetyTypeBuffer = 50;

const lgChannelPillWidthPx = 100;
const lgPptyTypePillWidthPx = 192;
const lgPricePillWidthPx = 173;
const lgFloorAreaPillWidthPx = 213;
const lgAllFiltersBtnWidthPx = 136;
const smallSwitchMapBtnWidthPx = 64;
const switchMapBtnWidthPx = 204;
const searchBoxWPaddingWidthPx = 376;
const lgsearchBarPaddingPx = 32;

export const smPropertyTypesPillReqWidthPx =
  smChannelPillWidthPx +
  smPptyTypePillWidthPx +
  smAllFiltersBtnWidthPx +
  smallSwitchMapBtnWidthPx +
  smlHidePropetyTypeBuffer +
  pillPaddingPx * 2;
export const smPricePillReqWidthPx =
  smPropertyTypesPillReqWidthPx + smPricePillWidthPx + pillPaddingPx;
export const smFloorAreaReqWidthPx = smPricePillReqWidthPx + smFloorAreaPillWidthPx + btnPaddingPx;

export const lgPropertyTypesPillReqWidthPx =
  searchBoxWPaddingWidthPx +
  lgChannelPillWidthPx +
  lgPptyTypePillWidthPx +
  lgAllFiltersBtnWidthPx +
  pillPaddingPx +
  switchMapBtnWidthPx +
  btnPaddingPx +
  lgsearchBarPaddingPx;
export const lgPricePillReqWidthPx =
  lgPropertyTypesPillReqWidthPx + lgPricePillWidthPx + pillPaddingPx;
export const lgFloorAreaReqWidthPx = lgPricePillReqWidthPx + lgFloorAreaPillWidthPx + pillPaddingPx;
